<template>
  <div>
    <div class="loader-class" v-if="!smsSent">
      <div class="loader"></div>
    </div>
    <div v-else>
      <div v-if="!otp_confirmed">
        <!-- <div>
					<button
							type="submit"
							v-if="!smsSent"
							@click.prevent="genrateOTP()"
							id="popover-button-event"
							:disabled="checkSmsPassedValue"
							class="btn btn-solid btn-block"
						>
							{{_T('Please confirm your phone number')}}
						</button>
          
        </div> -->
        <b-form-invalid-feedback :state="otp_progress_fail && !smsSent">
          {{ otp_verification.error_message[0] }}
        </b-form-invalid-feedback>
        <div :v-if="smsSent" :title="_T('Phone number confirmation')">
          <form class="default-form verification-code" v-if="smsSent">
            <div class="form-group">
              <label>
                <span
                  >{{
                    _T('A verification code has been sent to the number')
                  }}
                  ({{ otp_progress_reference }})</span
                >
              </label>
              <div class="digit-group">
                <input
                  type="text"
                  :id="'digit-' + index"
                  :name="'digit-' + randStr()"
                  :data-next="'digit-' + (index + 1)"
                  :ref="'digit-ref-' + index"
                  :key="index"
                  v-for="(item, index) in inputFields"
                  v-model="inputFields[index]"
                  @input="handleOnChange($event, index)"
                  @keydown="handleOnKeyDown($event, index)"
                  @keyup="handleKeyUp($event, index)"
                  @focus="handleOnFocus($event, index)"
                  autocomplete="new-password"
                />
              </div>
              <b-form-invalid-feedback :state="otp_progress_fail">
                {{ otp_verification.error_message }}
              </b-form-invalid-feedback>
            </div>
            <button
              type="button"
              class="btn btn-danger btn-block"
              @click="confirmOTP"
            >
              {{ _T('Verify') }}
            </button>
            <h6>
              {{ _T('Did not received code?') }}
              <span class="font-primary resend-code" @click="genrateOTP">{{
                _T('Resend')
              }}</span>
            </h6>
          </form>
        </div>
      </div>
      <div v-else>
        <p>{{ _T('Your phone number is confirmed!') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { mapGetters } from 'vuex'
import * as CONST from '@/constants'
import { generateRandomString } from '@/utils/main_utils'

export default {
  name: 'SMSConfirmation',
  computed: {
    ...mapGetters([
      '_T',
      'otp_verification',
      'otp_progress',
      'otp_progress_fail',
      'otp_confirmed',
      'otp_progress_reference',
    ]),
    code() {
      return this.inputFields.join('')
    },
  },
  props: ['phone_number', 'smsSent'],
  data() {
    return {
      inputFields: [],
      checkSmsPassedValue: false,
    }
  },
  mounted() {
    for (var i = 0; i < CONST.OTP_LENGTH; i++) this.inputFields.push('')
  },
  methods: {
    handleOnChange(event, currentIndex) {
      this.oneValuePerInput()
      return this.$emit('on-change', this.model)
    },
    handleKeyUp(event, currentIndex) {
      this.oneValuePerInput()
      if (currentIndex + 1 != CONST.OTP_LENGTH && event.key != 'Backspace') {
        this.$refs['digit-ref-' + (currentIndex + 1)][0].value = ''
        this.$refs['digit-ref-' + (currentIndex + 1)][0].focus()
        
      }
    },
    handleOnKeyDown(event, currentIndex) {
      // Only allow characters 0-9, DEL, Backspace and Pasting
      const keyevent = event || window.event
      const charCode = keyevent.which ? keyevent.which : keyevent.keyCode
      if (
        this.isCodeNumeric(charCode) ||
        charCode === 8 ||
        charCode === 86 ||
        charCode === 46
      ) {
        this.$emit('on-keydown', event)
      } else {
        keyevent.preventDefault()
      }
      this.oneValuePerInput()
    },
    oneValuePerInput() {
      let that = this
      this.inputFields.forEach((element, k) => {
        if (String(element).length > 1) {
          that.inputFields[k] = element.slice('')[0]
        }
      })
    },
    isCodeNumeric(charCode) {
      return (
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 96 && charCode <= 105)
      )
    },
    handleOnFocus(event, currentIndex) {
      this.oneValuePerInput()
      return this.$emit('on-focus')
    },
    genrateOTP() {
      var that = this
      that.inputFields.forEach((e, i) => {
        that.inputFields[i] = ''
      })
      this.$store
        .dispatch('sendOTP', {
          mode: 'mobile',
          reference: this.phone_number,
        })
        .then(() => {
          that.smsSent = true
          that.$emit('smssendsuccessfully',true)
        })
    },
    confirmOTP() { 
      var that = this
      this.$store.dispatch('confirmOTP', this.code).then(() => {
        if (that.otp_confirmed) {
          that.$emit('mobileconfirmedsuccessfully',true)
          this.$store.commit('UNSET_OTP_IN_PROGRESS')
          that.$emit('mobileconfirmed',true)
          that.$emit('onSuccess', that.otp_confirmed)
          that.inputFields.forEach((e, i) => {
            that.inputFields[i] = ''
          })
        }
      })
    },
    randStr() {
      return generateRandomString()
    },
  },
  watch: {
    inputFields() {},
  },
}
</script>

<style lang="scss" scoped>
.invalid-feedback {
  font-size: $px14;
  font-weight: 500;
}
.loader-class {
  width: 100%;
  height: $px170;
  position: relative;
  .loader {
    border: $px3 solid $light-border;
    border-bottom-color: transparent;
    border-radius: 50%;
    animation: 1s loader linear infinite;
    position: relative;
    display: inline-block;
    width: 2em;
    height: 2em;
    color: inherit;
    vertical-align: middle;
    pointer-events: none;
    position: absolute;
    top: 40%;
    left: 45%;
    transform: translate(-50%, -50%);
  }
}
@keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.resend-code {
  cursor: pointer;
}
</style>
